import { render } from "./BreadcrumbsMenu.vue?vue&type=template&id=08e34694&scoped=true"
import script from "./BreadcrumbsMenu.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsMenu.vue?vue&type=script&lang=js"

import "./BreadcrumbsMenu.vue?vue&type=style&index=0&id=08e34694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e34694"]])

export default __exports__